import React, {useEffect} from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import {Fab, Typography, Button,Paper, StepButton, Step, Stepper, Breadcrumbs} from '@mui/material';
///@core components
import GridItem from "../../components/Grid/GridItem";
import {useSelector, useDispatch} from 'react-redux';
import Support from '../../components/support/Support';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import GridContainer from "../../components/Grid/GridContainer";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader";
import CardBody from "../../components/Card/CardBody";
import styles1 from "../../components/assets/jss/material-dashboard-react/views/dashboardStyle.js";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableContainer from '@mui/material/TableContainer';
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { baseUrl } from '../../components/shared/baseUrl';
import { CircularProgressbar,buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import {
  grayColor
} from "../../components/assets/jss/material-dashboard-react.js";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  '&.MuiTableCell-head': {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  '&.MuiTableCell-body': {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
})); 


const styles = (theme) => ({
  cardTitle: {
            color: 'blue',
            marginTop: "0px",
            minHeight: "auto",
            fontWeight: "300",
            fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
            marginBottom: "3px",
            textDecoration: "none",
            "& small": {
              color: grayColor[1],
              fontWeight: "400",
              lineHeight: "1"
            }
          },
  cardCategory: {
            color: grayColor[0],
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            paddingTop: "10px",
            marginBottom: "0"
          },
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  completed: {
    display: 'inline-block',
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
});

//const useStyles1 = makeStyles(styles1);

const getSteps=()=> {
  return ['Activity1', 'Activity2', 'Activity3', 'Activity4','Activity5', 'Activity6', 'Activity7', 'Activity8'];
}

export default function GroupWork(props) {
    const theme = useTheme()
    const classes = styles(theme);
    var interval = null
    const [activeStep, setActiveStep] = React.useState(0);
    const [completed, setCompleted] = React.useState({});
    const steps = getSteps();
    const [clas, setclas]=React.useState([])
    const [sess, setsess]=React.useState([])
    const [mydata, setmydata]=React.useState([])
    const [analytics, setanalytics]=React.useState([])
    const [loading, setloading]=React.useState(true)
    const [score, setscore] = React.useState(0);
    const [loadsupport, setloadsupport] = React.useState(false);
    const user = useSelector(state => state.user)
    const [done, setdone]=React.useState(false)
    const { classId, sesId, userId, id } = useParams();
  ///console.log(activeStep)


  useEffect(() => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();      
    
    const loadData=()=>{

    //const classId = classId;
    //const sesId = sesId;
    //const groupId = grpId;


    // console.log(props)
    axios.get(`${baseUrl}class/${classId}`)
    .then((response) => {
    setclas(response.data)
    const dat = Array.from(response.data.sessions)
    const sess=Array.from(response.data.sessions).filter((ses)=> ses._id == sesId)
    console.log(sess);
    console.log(sesId);
    setsess(sess)
    axios.get(`${baseUrl}pyinterpreter/profile/${userId}/`, { cancelToken: source.token })
    .then((response) =>{
      console.log(response.data)
      setmydata(response.data)
    var act = response.data.activity1
      if (response.data.activity1[0].completed==true){
        setdone(true)
      }

      //profileCalculate(act)


  //     try{
  //       getData(userId)
  //       interval = setInterval(() => {
  //           //console.log('Interval is working')
  //           getData(userId);
  //       }, 3000);

   
  // } catch (error) {
  //     if (axios.isCancel(error)) {
  //       console.log("cancelled");
  //     } else {
  //       throw error;
  //     }
  //   }

      setloading(false)

    })



    })
    .catch((error)=>{
    console.log(error);
    });
  }

  loadData();


  return() => {source.cancel();};
   
 }, []);

 const getData = (sessid) =>{
  const config = {
    headers: { Authorization: `Bearer ${user.token}` }
};
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
      .then((response) =>{
        console.log(response.data)
        setmydata(response.data)
               

  })

}
  
const Notification = (act) => {
  var query=mydata.support.filter((ses)=> ses.activity == act)
  
  var newQuery = false;
  if(query.length>0){
  const length = query.length;
  const lastMsg = new Date(query[length-1].created)
  const lastVisit = new Date(mydata.lastViewSupport)
 

  if(lastVisit < lastMsg){
    newQuery = true
  }
}
    return newQuery
}

 const tableAnalytics = (activity,actnew) =>{
  var stat = []
  //profileCalculate(activity)
  var profileScore=0
  var previousScore = 60
  var minutesDeco=0
  var minutesPat=0
  var minutesAbs=0
  var minutesAlgo=0
  var minutesAn=0
  var totalAlternate=0
  var minutesDecoAlt=0
  var minutesPatAlt=0
  var minutesAbsAlt=0
  var minutesAlgoAlt=0
  var minutesAnAlt=0
  console.log(activity)
  // setmydata(activity[0])

  ////for decomposition
  var startDeco = new Date(activity[0].decomposition[0].created) 
  var finalDeco = new Date(activity[0].decomposition[0].finalTime)
  if(startDeco<finalDeco){
      minutesDeco = (finalDeco - startDeco)/(1000*60)
  }
  ///for alternate in decomposition
  activity[0].decomposition[0].alternateSolution.map((text,index)=>{
      var altstart = new Date(text.created)
      var altfinal = new Date(text.finalTime)
      if(altstart<altfinal){
          var diff = (altfinal - altstart)/(1000*60)
      }
      totalAlternate=totalAlternate+diff
  })
  minutesDecoAlt=totalAlternate
  minutesDeco=minutesDeco-totalAlternate


  ////for pattern
      totalAlternate=0
      startDeco = new Date(activity[0].pattern[0].created) 
      finalDeco = new Date(activity[0].pattern[0].finalTime)
  if(startDeco<finalDeco){
      minutesPat = (finalDeco - startDeco)/(1000*60)
  } 
  ///for alternate in pattern
  activity[0].pattern[0].alternateSolution.map((text,index)=>{
      var altstart = new Date(text.created)
      var altfinal = new Date(text.finalTime)
      if(altstart<altfinal){
          var diff = (altfinal - altstart)/(1000*60)
      }
      totalAlternate=totalAlternate+diff
  })
  minutesPatAlt=totalAlternate
  minutesPat=minutesPat-totalAlternate

  /////for abstraction
  totalAlternate=0
  startDeco = new Date(activity[0].abstraction[0].created) 
  finalDeco = new Date(activity[0].abstraction[0].finalTime)
  if(startDeco<finalDeco){
      minutesAbs = (finalDeco - startDeco)/(1000*60)
  }
  
  ///for alternate in abstraction
  activity[0].abstraction[0].alternateSolution.map((text,index)=>{
      var altstart = new Date(text.created)
      var altfinal = new Date(text.finalTime)
      if(altstart<altfinal){
          var diff = (altfinal - altstart)/(1000*60)
      }
      totalAlternate=totalAlternate+diff
  })
  minutesAbsAlt=totalAlternate
  minutesAbs=minutesAbs-totalAlternate

  /////for algorithm
  totalAlternate=0
  startDeco = new Date(activity[0].algorithm[0].created) 
  finalDeco = new Date(activity[0].algorithm[0].finalTime)
  if(startDeco<finalDeco){
      minutesAlgo = (finalDeco - startDeco)/(1000*60)
  }

  ///for alternate in algorithm
  activity[0].algorithm[0].alternateSolution.map((text,index)=>{
      var altstart = new Date(text.created)
      var altfinal = new Date(text.finalTime)
      if(altstart<altfinal){
          var diff = (altfinal - altstart)/(1000*60)
      }
      totalAlternate=totalAlternate+diff
  })
  minutesAlgoAlt=totalAlternate
  minutesAlgo=minutesAlgo-totalAlternate

  //////for analysis
  totalAlternate=0
  startDeco = new Date(activity[0].analysis[0].created) 
  finalDeco = new Date(activity[0].analysis[0].finalTime)
  if(startDeco<finalDeco){
      minutesAn = (finalDeco - startDeco)/(1000*60)
  } 
  ///for alternate in analysis            
  minutesAnAlt=totalAlternate
  

  var analyticStatus = [];              

      analyticStatus.push({
          step:'Decomposition',
          attempts:activity[0].decomposition[0].noOfattempts,
          altattempts:activity[0].decomposition[0].noOfaltattempts,
          hints:activity[0].decomposition[0].levelOfHints,
          time:minutesDeco.toFixed(2),
          alttime:minutesDecoAlt.toFixed(2)
      })
      analyticStatus.push({
          step:'Pattern',
          attempts:activity[0].pattern[0].noOfattempts,
          altattempts:activity[0].pattern[0].noOfaltattempts,
          hints:activity[0].pattern[0].levelOfHints,
          time:minutesPat.toFixed(2),
          alttime:minutesPatAlt.toFixed(2)
      })
      analyticStatus.push({
          step:'Abstraction',
          attempts:activity[0].abstraction[0].noOfattempts,
          altattempts:activity[0].abstraction[0].noOfaltattempts,
          hints:activity[0].abstraction[0].levelOfHints,
          time:minutesAbs.toFixed(2),
          alttime:minutesAbsAlt.toFixed(2)
      })
      analyticStatus.push({
          step:'Algorithm',
          attempts:activity[0].algorithm[0].noOfattempts,
          altattempts:activity[0].algorithm[0].noOfaltattempts,
          hints:activity[0].algorithm[0].levelOfHints,
          time:minutesAlgo.toFixed(2),
          alttime:minutesAlgoAlt.toFixed(2)
      })
      analyticStatus.push({
          step:'Analysis',
          attempts:activity[0].analysis[0].noOfattempts,
          altattempts:activity[0].analysis[0].noOfaltattempts,
          hints:activity[0].analysis[0].levelOfHints,
          time:minutesAn.toFixed(2),
          alttime:minutesAnAlt.toFixed(2)
      })
      var hintscore=0
      var attscore=0
      var timescore=0
      analyticStatus.map((text,index)=>{
          
          if(text.hints=='Basic'){
              hintscore=hintscore+3
          }
          if(text.hints=='Intermediate'){
              hintscore=hintscore+2
          }
          if(text.hints=='Advanced'){
              hintscore=hintscore+1
          }
          attscore=attscore+parseInt(text.attempts)
          timescore=timescore+Number(text.time)
      })
      if(Number(timescore)<50){
          timescore=50
      }
      console.log('My scores '+attscore+', '+hintscore+', '+timescore)
      profileScore=hintscore+50/attscore+500/timescore
      profileScore=(profileScore/35)*100
      previousScore = Number(activity[0].profileScore)
      var k=1
      if(activity[0].level=='medium'){
          k=2
      }
      if(activity[0].level=='easy'){
          k=3
      }
      console.log(k)
      if(previousScore>profileScore){
          profileScore=(profileScore+k*previousScore)/(1+k)
      }
      else{
          profileScore=(previousScore+k*profileScore)/(1+k)
      }
     

  return(
      <>
        <GridItem xs={12} sm={12} md={9}>
          <h5 align='center'> Analytics for each step</h5>
          <TableContainer component={Paper}>
            <Table sx={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>CT Step</StyledTableCell>
                        <StyledTableCell align="right">Level of hints&nbsp;</StyledTableCell>
                        <StyledTableCell align="right">Submission attempts</StyledTableCell>
                        <StyledTableCell align="right">Time taken (in mins)&nbsp;</StyledTableCell>
                        <StyledTableCell align="right">Submission attempts(Alternate solution)</StyledTableCell>
                        <StyledTableCell align="right">Time taken (for Alternate solution in mins)&nbsp;</StyledTableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                {analyticStatus.map((row) => (
                     
                    <StyledTableRow key={row.step}>
                        <StyledTableCell component="th" scope="row">
                            {row.step}
                        </StyledTableCell>
                        <StyledTableCell align="right">{row.hints}</StyledTableCell>
                        <StyledTableCell align="right">{row.attempts}</StyledTableCell>
                        <StyledTableCell align="right">{row.time}</StyledTableCell>
                        <StyledTableCell align="right">{row.altattempts}</StyledTableCell>
                        <StyledTableCell align="right">{row.alttime}</StyledTableCell>
                    </StyledTableRow>
                ))}
                </TableBody>
              </Table>
            </TableContainer>
          </GridItem>
        <GridItem xs={12} sm={12} md={3}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Fab color="secondary" aria-label="add" size="small" component="span" onClick={Togglesupport}>    
                <ContactSupportIcon /> {Notification(actnew)==true?'1':null}
              </Fab>
              <p>Support User</p>
                  
              {loadsupport === true?loading !== true?
              <Support user = {mydata._id} act = {actnew} classid = {classId} type='teacher'/>:null:null}
            </GridItem>
          </GridContainer>
        </GridItem>
      </>
  )
 }

 const Togglesupport = () =>{
  setloadsupport(!loadsupport)
  
}
  const commaToText = (txt) =>{
    var mytext = ''
    if(txt!='' && typeof(txt)!=='undefined'){ 
    if(txt.includes(',')==true){
      var newArr = txt.split(',')
      var i=0
      while(newArr[i]!==''&& i<newArr.length && newArr[i]!=='undefined'){
            mytext=mytext+' '+newArr[i]
            i=i+1
        }  
      
       return mytext
    }
    else{
      return txt
    }
  }
  return txt
    
 }


  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    if(handleCompletion(activeStep+1)=='(done)'){
      setdone(true)
    }
    else{
      setdone(false)
    }

    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setdone(true)
    
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleCompletion = (num) => {
      if(num==0){
        if(mydata.activity1[0].completed==true){
          return '(done)'
        }
        else{
          return '(not done)'
        }
      }
      else if(num==1){
        if(mydata.activity2[0].completed==true){
          return '(done)'
        }
        else{
          return '(not done)'
        }
      }
      else if(num==2){
        if(mydata.activity3[0].completed==true){
          return '(done)'
        }
        else{
          return '(not done)'
        }
      }
      else if(num==3){
        if(mydata.activity4[0].completed==true){
          return '(done)'
        }
        else{
          return '(not done)'
        }
      }
      else if(num==4){
        if(mydata.activity5[0].completed==true){
          return '(done)'
        }
        else{
          return '(not done)'
        }
      }
      else if(num==5){
        if(mydata.activity6[0].completed==true){
          return '(done)'
        }
        else{
          return '(not done)'
        }
      }

  };

  const totalSolutionComparison =(deco,pattern,abs,algorithm,time,space,k,step)=>{

    
  
      const algoText = (txt) =>{
        var tex = txt.split(';')
        var stex=[]
        if(tex.length==4){
          if(typeof(tex[2])!=='undefined'){
            if(tex[2].includes('set')==true){
              stex = tex[2].split('set')
            }
          }
        }
        else if(tex.length>4){
          if(typeof(tex[3])!=='undefined'){
            if(tex[3].includes('set')==true){
            stex = tex[3].split('set')
            }
          }
        }
        return (<div>
            {tex.length==4?
            <GridContainer>
                <GridItem xs={12} sm={12} md={5}>
                    input statement:
                </GridItem>
                <GridItem xs={12} sm={12} md={7}>
                     {commaToText(tex[0])}
                </GridItem>
                <GridItem xs={12} sm={12} md={5}>
                    define variable:
                </GridItem>
                <GridItem xs={12} sm={12} md={7} >
                     {commaToText(tex[1])} 
                </GridItem>
                <GridItem xs={12} sm={12} md={5}>
                    set variable:
                </GridItem>
                <GridItem xs={12} sm={12} md={7} >
                  {stex.map((val, index)=>{
                    if(index>0){
                    return(
                      <div>{commaToText('set'+val)}</div>
                    )
                    }
                    else{
                      return(
                      <div>{commaToText(val)}</div>
                      )
                    }
                  })}
                </GridItem>
                <GridItem xs={12} sm={12} md={5}>
                    output statement:
                </GridItem>
                <GridItem xs={12} sm={12} md={7} >
                    {commaToText(tex[3])}
                </GridItem>
            </GridContainer>:
            <GridContainer>
                <GridItem xs={12} sm={12} md={5}>
                    input statement:
                </GridItem>
                <GridItem xs={12} sm={12} md={7}>
                    {commaToText(tex[0])}
                </GridItem>
                <GridItem xs={12} sm={12} md={5}>
                    define variable:
                </GridItem>
                <GridItem xs={12} sm={12} md={7} >
                    {commaToText(tex[1])} {commaToText(tex[2])}
                </GridItem>
                <GridItem xs={12} sm={12} md={5}>
                    set variable:
                </GridItem>
                <GridItem xs={12} sm={12} md={7} >
                    {stex.map((val, index)=>{
                      if(index>0){
                      return(
                        <div>{commaToText('set'+val)}</div>
                      )
                      }
                      else{
                        return(
                        <div>{commaToText(val)}</div>
                        )
                      }
                    })}
                </GridItem>
                <GridItem xs={12} sm={12} md={5}>
                    output statement:
                </GridItem>
                <GridItem xs={12} sm={12} md={7} >
                    {commaToText(tex[4])}
                </GridItem>
            </GridContainer>}
            </div>
        )
     }
      return (
        <>
            <Card>
                  <b align="center">{k=='1'? 'Current Solution':'Alternate Solution'}</b>
              <CardBody>
                <b> Decomposition </b>
                <p style={step=='decomposition'?{ ...classes.cardTitle }:null}>{commaToText(deco)}</p>
                <b> Pattern </b>
                <p style={step=='pattern'?{ ...classes.cardTitle }:null}>{commaToText(pattern)}</p>
                <b> Abstraction </b>
                <p style={step=='abstraction'?{ ...classes.cardTitle }:null}>{commaToText(abs)}</p>
                <b> Algorithm </b>
                <p style={step=='algorithm'?{ ...classes.cardTitle }:null}>{algoText(algorithm)}</p>
                <b> Analysis</b>
                <p style={classes.cardCategory}>
                  No. of operations={time},No. of variables={space}  </p>
              </CardBody>
            </Card>
            
          </>              
          );
        }



  return (
    loading!=true?
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>

        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            <Link color="inherit" to="/admin/dashboard">
                    Dashboard
            </Link>
            <Link color="inherit" to={`/admin/dashboard/viewclass/${clas._id}`}>
                <Typography color="textPrimary">{clas.title}</Typography>
            </Link>

            <Link color="inherit" to={`/admin/dashboard/viewclass/${clas._id}/viewsession/${sesId}`}>
              {loading!==true?
              <Typography color="textPrimary">
                  Monitoring Scenario({sess[0].title}) 
              </Typography>:null}
            </Link>
            <Typography color="textPrimary" variant="h5" className="text-center">
              View Work {id}                
            </Typography>  
        </Breadcrumbs>
      </GridItem>
    <div style={classes.root}>
      <Stepper nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepButton 
            // onClick={handleStep(index)} 
            completed={completed[index]}>
              {label}{handleCompletion(index)}
            </StepButton>
          </Step>
        ))}
      </Stepper>
      <div>

      <GridContainer>

        {activeStep==0?<>
                    <GridItem xs={12} sm={12} md={12}>
                      <h5 id="simple-modal-description" align="center"> {mydata.activity1[0].problemStatement} </h5>
                    </GridItem>
                    
                    <GridContainer spacing={2}>
                                {mydata.activity1[0].decomposition[0].alternateSolution.map((text, index)=>{
                                  if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){

                                  if(text.algorithm.includes('nitesh')==true){
                                    var newalgo=text.algorithm.split('nitesh')
                                  }
                                  var tim=''
                                  var spc=''
                                  if(text.analysis.includes(',')==true){
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    tim = newarr1[1]
                                    spc = newarr2[1]
                                  }
                                  
                                    return (
                                      text.algoCompleted==true?
                                      
                                      <GridItem xs={12} sm={6} md={6} key={index}>
                                          {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','decomposition')}
                                      </GridItem> 
                                      :null
                                    )}})}
                                  {mydata.activity1[0].pattern[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                    var len=0;
                                    if(typeof(mydata.activity1[0].decomposition[0].alternateSolution.length)!='undefined'){
                                      len=mydata.activity1[0].decomposition[0].alternateSolution.length
                                    }
                                    if(text.algorithm.includes('nitesh')==true){
                                      var newalgo=text.algorithm.split('nitesh')
                                    }
                                    var tim=''
                                    var spc=''
                                    if(text.analysis.includes(',')==true){
                                      var arr = text.analysis.split(',')
                                      var newarr1=arr[0].split('=')
                                      var newarr2=arr[1].split('=')
                                      tim = newarr1[1]
                                      spc = newarr2[1]
                                    }
                                    return (
                                    text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={6} key={index}>
                                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','pattern')}
                                    </GridItem> 
                                     :null
                                  )}})}
                                  {mydata.activity1[0].abstraction[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                  var len=0;
                                  if(typeof(mydata.activity1[0].decomposition[0].alternateSolution.length)!='undefined'){
                                    len=mydata.activity1[0].decomposition[0].alternateSolution.length
                                  }
                                  if(typeof(mydata.activity1[0].pattern[0].alternateSolution.length)!='undefined'){
                                    len=len+mydata.activity1[0].pattern[0].alternateSolution.length
                                  }
                                  if(text.algorithm.includes('nitesh')==true){
                                    var newalgo=text.algorithm.split('nitesh')
                                  }
                                  var tim=''
                                  var spc=''
                                  if(text.analysis.includes(',')==true){
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    tim = newarr1[1]
                                    spc = newarr2[1]
                                  }
                                  return (
                                  text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={6} key={index}>
                                      {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','abstraction')}
                                    </GridItem>  
                                  :null
                                  )}})}
                                  {mydata.activity1[0].algorithm[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                    var len=0;
                                    if(typeof(mydata.activity1[0].decomposition[0].alternateSolution.length)!='undefined'){
                                      len=mydata.activity1[0].decomposition[0].alternateSolution.length
                                    }
                                    if(typeof(mydata.activity1[0].pattern[0].alternateSolution.length)!='undefined'){
                                      len=len+mydata.activity1[0].pattern[0].alternateSolution.length
                                    }
                                    if(typeof(mydata.activity1[0].abstraction[0].alternateSolution.length)!='undefined'){
                                      len=len+mydata.activity1[0].abstraction[0].alternateSolution.length
                                    }
                                    if(text.algorithm.includes('nitesh')==true){
                                      var newalgo=text.algorithm.split('nitesh')
                                    }
                                    var tim=''
                                    var spc=''
                                    if(text.analysis.includes(',')==true){
                                      var arr = text.analysis.split(',')
                                      var newarr1=arr[0].split('=')
                                      var newarr2=arr[1].split('=')
                                      tim = newarr1[1]
                                      spc = newarr2[1]
                                    }
                                    return (
                                    text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={6} key={index}>
                                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','algorithm')}
                                    </GridItem> 
                                      :null
                                    )}})}
                                    <GridItem xs={12} sm={12} md={6}>
                                      {totalSolutionComparison(mydata.activity1[0].decomposition[0].userText,mydata.activity1[0].pattern[0].userText,mydata.activity1[0].abstraction[0].userText,
                                        mydata.activity1[0].algorithm[0].userText,mydata.activity1[0].analysis[0].timeText,mydata.activity1[0].analysis[0].spaceText,1,'correct')}
                                </GridItem>

                                <GridItem xs={12} sm={12} md={4}>
                                  {mydata.activity1[0].completed==true?
                                    <Card >
                                        <CardHeader color="success">
                                            <h5 style={classes.cardTitleWhite}> Overall Profile Score </h5>
                                        </CardHeader>
                                        <CardBody>
                                              <div style={{ width: "70%" }}>
                                                <CircularProgressbar
                                                        value={Number(mydata.activity1[0].profileScore).toFixed(2)}
                                                        text={`${Number(mydata.activity1[0].profileScore).toFixed(2)}%`}
                                                        background
                                                        backgroundPadding={6}
                                                        styles={buildStyles({
                                                        backgroundColor: "#3e98c7",
                                                        textColor: "#fff",
                                                        pathColor: "#fff",
                                                        trailColor: "transparent"
                                                        
                                                        
                                                        })}
                                              
                                                    /> 
                                              </div>                                            
                                        </CardBody>
                                    </Card>:null}
                                </GridItem>
                        </GridContainer>
                        {tableAnalytics(mydata.activity1,'activity1')}
                        </>
        :activeStep==1?<>
                  <GridItem xs={12} sm={12} md={12}>
                    <h5 id="simple-modal-description" align="center"> {mydata.activity2[0].problemStatement} </h5>
                  </GridItem>
                <GridContainer spacing={2}>
                                {mydata.activity2[0].decomposition[0].alternateSolution.map((text, index)=>{
                                  if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                  if(text.algorithm.includes('nitesh')==true){
                                    var newalgo=text.algorithm.split('nitesh')
                                  }
                                  var tim=''
                                  var spc=''
                                  if(text.analysis.includes(',')==true){
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    tim = newarr1[1]
                                    spc = newarr2[1]
                                  }
                                    return (
                                      text.algoCompleted==true?
                                      
                                      <GridItem xs={12} sm={6} md={6} key={index}>
                                          {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','decomposition')}
                                      </GridItem> 
                                      :null
                                    )}})}
                                  {mydata.activity2[0].pattern[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                    var len=0;
                                    if(typeof(mydata.activity2[0].decomposition[0].alternateSolution.length)!='undefined'){
                                      len=mydata.activity2[0].decomposition[0].alternateSolution.length
                                    }
                                    if(text.algorithm.includes('nitesh')==true){
                                      var newalgo=text.algorithm.split('nitesh')
                                    }
                                    var tim=''
                                    var spc=''
                                    if(text.analysis.includes(',')==true){
                                      var arr = text.analysis.split(',')
                                      var newarr1=arr[0].split('=')
                                      var newarr2=arr[1].split('=')
                                      tim = newarr1[1]
                                      spc = newarr2[1]
                                    }
                                    return (
                                    text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={6} key={index}>
                                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','pattern')}
                                    </GridItem> 
                                     :null
                                  )}})}
                                  {mydata.activity2[0].abstraction[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                  var len=0;
                                  if(typeof(mydata.activity2[0].decomposition[0].alternateSolution.length)!='undefined'){
                                    len=mydata.activity2[0].decomposition[0].alternateSolution.length
                                  }
                                  if(typeof(mydata.activity2[0].pattern[0].alternateSolution.length)!='undefined'){
                                    len=len+mydata.activity2[0].pattern[0].alternateSolution.length
                                  }
                                  if(text.algorithm.includes('nitesh')==true){
                                    var newalgo=text.algorithm.split('nitesh')
                                  }
                                  var tim=''
                                  var spc=''
                                  if(text.analysis.includes(',')==true){
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    tim = newarr1[1]
                                    spc = newarr2[1]
                                  }
                                  return (
                                  text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={6} key={index}>
                                      {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','abstraction')}
                                    </GridItem>  
                                  :null
                                  )}})}
                                  {mydata.activity2[0].algorithm[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                    var len=0;
                                    if(typeof(mydata.activity2[0].decomposition[0].alternateSolution.length)!='undefined'){
                                      len=mydata.activity2[0].decomposition[0].alternateSolution.length
                                    }
                                    if(typeof(mydata.activity2[0].pattern[0].alternateSolution.length)!='undefined'){
                                      len=len+mydata.activity2[0].pattern[0].alternateSolution.length
                                    }
                                    if(typeof(mydata.activity2[0].abstraction[0].alternateSolution.length)!='undefined'){
                                      len=len+mydata.activity2[0].abstraction[0].alternateSolution.length
                                    }
                                    if(text.algorithm.includes('nitesh')==true){
                                      var newalgo=text.algorithm.split('nitesh')
                                    }
                                    var tim=''
                                    var spc=''
                                    if(text.analysis.includes(',')==true){
                                      var arr = text.analysis.split(',')
                                      var newarr1=arr[0].split('=')
                                      var newarr2=arr[1].split('=')
                                      tim = newarr1[1]
                                      spc = newarr2[1]
                                    }
                                    return (
                                    text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={6} key={index}>
                                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','algorithm')}
                                    </GridItem> 
                                      :null
                                    )}})}
                                    <GridItem xs={12} sm={12} md={6}>
                                      {totalSolutionComparison(mydata.activity2[0].decomposition[0].userText,mydata.activity2[0].pattern[0].userText,mydata.activity2[0].abstraction[0].userText,
                                        mydata.activity2[0].algorithm[0].userText,mydata.activity2[0].analysis[0].timeText,mydata.activity2[0].analysis[0].spaceText,1,'correct')}
                                </GridItem>
                                <GridItem xs={12} sm={12} md={4}>
                                  {mydata.activity2[0].completed==true?
                                    <Card>
                                        <CardHeader color="success">
                                            <h5 style={classes.cardTitleWhite}> Overall Profile Score </h5>
                                        </CardHeader>
                                        <CardBody>
                                            <div style={{ width: "70%" }}>
                                                <CircularProgressbar
                                                        value={Number(mydata.activity2[0].profileScore).toFixed(2)}
                                                        text={`${Number(mydata.activity2[0].profileScore).toFixed(2)}%`}
                                                        background
                                                        backgroundPadding={6}
                                                        styles={buildStyles({
                                                        backgroundColor: "#3e98c7",
                                                        textColor: "#fff",
                                                        pathColor: "#fff",
                                                        trailColor: "transparent"
                                                        })}
                                                    /> 
                                              </div>                                            
                                        </CardBody>
                                    </Card>:null}
                                </GridItem>
                        </GridContainer>
                        {tableAnalytics(mydata.activity2,'activity2')}
                        </>
        :activeStep==2?
            <>
              <GridItem xs={12} sm={12} md={12}>
                <h5 id="simple-modal-description" align="center"> {mydata.activity3[0].problemStatement} </h5>
              </GridItem>
              <GridContainer spacing={2}>
              {mydata.activity3[0].decomposition[0].alternateSolution.map((text, index)=>{
                if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                if(text.algorithm.includes('nitesh')==true){
                  var newalgo=text.algorithm.split('nitesh')
                }
                var tim=''
                var spc=''
                if(text.analysis.includes(',')==true){
                  var arr = text.analysis.split(',')
                  var newarr1=arr[0].split('=')
                  var newarr2=arr[1].split('=')
                  tim = newarr1[1]
                  spc = newarr2[1]
                }
                  return (
                    text.algoCompleted==true?
                    
                    <GridItem xs={12} sm={6} md={6} key={index}>
                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','decomposition')}
                    </GridItem> 
                    :null
                  )}})}
                {mydata.activity3[0].pattern[0].alternateSolution.map((text, index)=>{
                  if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                  var len=0;
                  if(typeof(mydata.activity3[0].decomposition[0].alternateSolution.length)!='undefined'){
                    len=mydata.activity3[0].decomposition[0].alternateSolution.length
                  }
                  if(text.algorithm.includes('nitesh')==true){
                    var newalgo=text.algorithm.split('nitesh')
                  }
                  var tim=''
                  var spc=''
                  if(text.analysis.includes(',')==true){
                    var arr = text.analysis.split(',')
                    var newarr1=arr[0].split('=')
                    var newarr2=arr[1].split('=')
                    tim = newarr1[1]
                    spc = newarr2[1]
                  }
                  return (
                  text.algoCompleted==true?
                  <GridItem xs={12} sm={6} md={6} key={index}>
                      {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','pattern')}
                  </GridItem> 
                  :null
                )}})}
                {mydata.activity3[0].abstraction[0].alternateSolution.map((text, index)=>{
                  if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                var len=0;
                if(typeof(mydata.activity3[0].decomposition[0].alternateSolution.length)!='undefined'){
                  len=mydata.activity3[0].decomposition[0].alternateSolution.length
                }
                if(typeof(mydata.activity3[0].pattern[0].alternateSolution.length)!='undefined'){
                  len=len+mydata.activity3[0].pattern[0].alternateSolution.length
                }
                if(text.algorithm.includes('nitesh')==true){
                  var newalgo=text.algorithm.split('nitesh')
                }
                var tim=''
                var spc=''
                if(text.analysis.includes(',')==true){
                  var arr = text.analysis.split(',')
                  var newarr1=arr[0].split('=')
                  var newarr2=arr[1].split('=')
                  tim = newarr1[1]
                  spc = newarr2[1]
                }
                return (
                text.algoCompleted==true?
                  <GridItem xs={12} sm={6} md={6} key={index}>
                    {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','abstraction')}
                  </GridItem>  
                :null
                )}})}
                {mydata.activity3[0].algorithm[0].alternateSolution.map((text, index)=>{
                  if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                  var len=0;
                  if(typeof(mydata.activity3[0].decomposition[0].alternateSolution.length)!='undefined'){
                    len=mydata.activity3[0].decomposition[0].alternateSolution.length
                  }
                  if(typeof(mydata.activity3[0].pattern[0].alternateSolution.length)!='undefined'){
                    len=len+mydata.activity3[0].pattern[0].alternateSolution.length
                  }
                  if(typeof(mydata.activity3[0].abstraction[0].alternateSolution.length)!='undefined'){
                    len=len+mydata.activity3[0].abstraction[0].alternateSolution.length
                  }
                  if(text.algorithm.includes('nitesh')==true){
                    var newalgo=text.algorithm.split('nitesh')
                  }
                                  var tim=''
                                  var spc=''
                                  if(text.analysis.includes(',')==true){
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    tim = newarr1[1]
                                    spc = newarr2[1]
                                  }
                  return (
                  text.algoCompleted==true?
                  <GridItem xs={12} sm={6} md={6} key={index}>
                      {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','algorithm')}
                  </GridItem> 
                    :null
                  )}})}
                  <GridItem xs={12} sm={12} md={6}>
                    {totalSolutionComparison(mydata.activity3[0].decomposition[0].userText,mydata.activity3[0].pattern[0].userText,mydata.activity3[0].abstraction[0].userText,
                      mydata.activity3[0].algorithm[0].userText,mydata.activity3[0].analysis[0].timeText,mydata.activity3[0].analysis[0].spaceText,1,'correct')}
              </GridItem>
                                <GridItem xs={12} sm={12} md={4}>
                                  {mydata.activity3[0].completed==true?
                                    <Card>
                                        <CardHeader color="success">
                                            <h5 style={classes.cardTitleWhite}> Overall Profile Score </h5>
                                        </CardHeader>
                                        <CardBody>
                                            <div style={{ width: "70%" }}>
                                                <CircularProgressbar
                                                        value={Number(mydata.activity3[0].profileScore).toFixed(2)}
                                                        text={`${Number(mydata.activity3[0].profileScore).toFixed(2)}%`}
                                                        background
                                                        backgroundPadding={6}
                                                        styles={buildStyles({
                                                        backgroundColor: "#3e98c7",
                                                        textColor: "#fff",
                                                        pathColor: "#fff",
                                                        trailColor: "transparent"
                                                        })}
                                                    />
                                            </div>                                             
                                        </CardBody>
                                    </Card>:null}
                                </GridItem>
            </GridContainer>
            {tableAnalytics(mydata.activity3,'activity3')}

          </>
        :activeStep==3?
        <>
            <GridItem xs={12} sm={12} md={12}>
              <h5 id="simple-modal-description" align="center"> {mydata.activity4[0].problemStatement} </h5>
            </GridItem>
        <GridContainer spacing={2}>
        {mydata.activity4[0].decomposition[0].alternateSolution.map((text, index)=>{
          if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
          if(text.algorithm.includes('nitesh')==true){
            var newalgo=text.algorithm.split('nitesh')
          }
                                  var tim=''
                                  var spc=''
                                  if(text.analysis.includes(',')==true){
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    tim = newarr1[1]
                                    spc = newarr2[1]
                                  }
            return (
              text.algoCompleted==true?
              
              <GridItem xs={12} sm={6} md={6} key={index}>
                  {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','decomposition')}
              </GridItem> 
              :null
            )}})}
          {mydata.activity4[0].pattern[0].alternateSolution.map((text, index)=>{
            if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
            var len=0;
            if(typeof(mydata.activity4[0].decomposition[0].alternateSolution.length)!='undefined'){
              len=mydata.activity4[0].decomposition[0].alternateSolution.length
            }
            if(text.algorithm.includes('nitesh')==true){
              var newalgo=text.algorithm.split('nitesh')
            }

                                  var tim=''
                                  var spc=''
                                  if(text.analysis.includes(',')==true){
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    tim = newarr1[1]
                                    spc = newarr2[1]
                                  }
            
            return (
            text.algoCompleted==true?
            <GridItem xs={12} sm={6} md={6} key={index}>
                {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','pattern')}
            </GridItem> 
            :null
          )}})}
          {mydata.activity4[0].abstraction[0].alternateSolution.map((text, index)=>{
            if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
          var len=0;
          if(typeof(mydata.activity4[0].decomposition[0].alternateSolution.length)!='undefined'){
            len=mydata.activity4[0].decomposition[0].alternateSolution.length
          }
          if(typeof(mydata.activity4[0].pattern[0].alternateSolution.length)!='undefined'){
            len=len+mydata.activity4[0].pattern[0].alternateSolution.length
          }
          if(text.algorithm.includes('nitesh')==true){
            var newalgo=text.algorithm.split('nitesh')
          }

                var tim=''
                var spc=''
                if(text.analysis.includes(',')==true){
                  var arr = text.analysis.split(',')
                  var newarr1=arr[0].split('=')
                  var newarr2=arr[1].split('=')
                  tim = newarr1[1]
                  spc = newarr2[1]
                }

          return (
          text.algoCompleted==true?
            <GridItem xs={12} sm={6} md={6} key={index}>
              {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','abstraction')}
            </GridItem>  
          :null
          )}})}
          {mydata.activity4[0].algorithm[0].alternateSolution.map((text, index)=>{
            if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
            var len=0;
            if(typeof(mydata.activity4[0].decomposition[0].alternateSolution.length)!='undefined'){
              len=mydata.activity4[0].decomposition[0].alternateSolution.length
            }
            if(typeof(mydata.activity4[0].pattern[0].alternateSolution.length)!='undefined'){
              len=len+mydata.activity4[0].pattern[0].alternateSolution.length
            }
            if(typeof(mydata.activity4[0].abstraction[0].alternateSolution.length)!='undefined'){
              len=len+mydata.activity4[0].abstraction[0].alternateSolution.length
            }
            if(text.algorithm.includes('nitesh')==true){
              var newalgo=text.algorithm.split('nitesh')
            }
                var tim=''
                var spc=''
                if(text.analysis.includes(',')==true){
                  var arr = text.analysis.split(',')
                  var newarr1=arr[0].split('=')
                  var newarr2=arr[1].split('=')
                  tim = newarr1[1]
                  spc = newarr2[1]
                }
            return (
            text.algoCompleted==true?
            <GridItem xs={12} sm={6} md={6} key={index}>
                {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','algorithm')}
            </GridItem> 
              :null
            )}})}
            <GridItem xs={12} sm={12} md={6}>
              {totalSolutionComparison(mydata.activity4[0].decomposition[0].userText,mydata.activity4[0].pattern[0].userText,mydata.activity4[0].abstraction[0].userText,
                mydata.activity4[0].algorithm[0].userText,mydata.activity4[0].analysis[0].timeText,mydata.activity4[0].analysis[0].spaceText,1,'correct')}
        </GridItem>
        
        <GridItem xs={12} sm={12} md={4}>
                                  {mydata.activity4[0].completed==true?
                                    <Card>
                                        <CardHeader color="success">
                                            <h5 style={classes.cardTitleWhite}> Overall Profile Score </h5>
                                        </CardHeader>
                                        <CardBody>
                                            <div style={{ width: "70%" }}>
                                                <CircularProgressbar
                                                        value={Number(mydata.activity4[0].profileScore).toFixed(2)}
                                                        text={`${Number(mydata.activity4[0].profileScore).toFixed(2)}%`}
                                                        background
                                                        backgroundPadding={6}
                                                        styles={buildStyles({
                                                        backgroundColor: "#3e98c7",
                                                        textColor: "#fff",
                                                        pathColor: "#fff",
                                                        trailColor: "transparent"
                                                        })}
                                                    />
                                            </div>                                             
                                        </CardBody>
                                    </Card>:null}
                                </GridItem>
    </GridContainer>
    {tableAnalytics(mydata.activity4,'activity4')}

    </>
        :activeStep==4?
        <>
                    <GridItem xs={12} sm={12} md={12}>
                      <h5 id="simple-modal-description" align="center"> {mydata.activity5[0].problemStatement} </h5>
                    </GridItem>
        <GridContainer spacing={2}>
              {mydata.activity5[0].decomposition[0].alternateSolution.map((text, index)=>{
                if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                if(text.algorithm.includes('nitesh')==true){
                  var newalgo=text.algorithm.split('nitesh')
                }
                var tim=''
                var spc=''
                if(text.analysis.includes(',')==true){
                  var arr = text.analysis.split(',')
                  var newarr1=arr[0].split('=')
                  var newarr2=arr[1].split('=')
                  tim = newarr1[1]
                  spc = newarr2[1]
                }
                  return (
                    text.algoCompleted==true?
                    
                    <GridItem xs={12} sm={6} md={6} key={index}>
                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','decomposition')}
                    </GridItem> 
                    :null
                  )}})}
                {mydata.activity5[0].pattern[0].alternateSolution.map((text, index)=>{
                  if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                  var len=0;
                  if(typeof(mydata.activity5[0].decomposition[0].alternateSolution.length)!='undefined'){
                    len=mydata.activity5[0].decomposition[0].alternateSolution.length
                  }
                  if(text.algorithm.includes('nitesh')==true){
                    var newalgo=text.algorithm.split('nitesh')
                  }
                  var tim=''
                  var spc=''
                  if(text.analysis.includes(',')==true){
                    var arr = text.analysis.split(',')
                    var newarr1=arr[0].split('=')
                    var newarr2=arr[1].split('=')
                    tim = newarr1[1]
                    spc = newarr2[1]
                  }
                  return (
                  text.algoCompleted==true?
                  <GridItem xs={12} sm={6} md={6} key={index}>
                      {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','pattern')}
                  </GridItem> 
                  :null
                )}})}
                {mydata.activity5[0].abstraction[0].alternateSolution.map((text, index)=>{
                  if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                var len=0;
                if(typeof(mydata.activity5[0].decomposition[0].alternateSolution.length)!='undefined'){
                  len=mydata.activity5[0].decomposition[0].alternateSolution.length
                }
                if(typeof(mydata.activity5[0].pattern[0].alternateSolution.length)!='undefined'){
                  len=len+mydata.activity5[0].pattern[0].alternateSolution.length
                }
                if(text.algorithm.includes('nitesh')==true){
                  var newalgo=text.algorithm.split('nitesh')
                }
                var tim=''
                var spc=''
                if(text.analysis.includes(',')==true){
                  var arr = text.analysis.split(',')
                  var newarr1=arr[0].split('=')
                  var newarr2=arr[1].split('=')
                  tim = newarr1[1]
                  spc = newarr2[1]
                }
                return (
                text.algoCompleted==true?
                  <GridItem xs={12} sm={6} md={6} key={index}>
                    {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','abstraction')}
                  </GridItem>  
                :null
                )}})}
                {mydata.activity5[0].algorithm[0].alternateSolution.map((text, index)=>{
                  if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                  var len=0;
                  if(typeof(mydata.activity5[0].decomposition[0].alternateSolution.length)!='undefined'){
                    len=mydata.activity5[0].decomposition[0].alternateSolution.length
                  }
                  if(typeof(mydata.activity5[0].pattern[0].alternateSolution.length)!='undefined'){
                    len=len+mydata.activity5[0].pattern[0].alternateSolution.length
                  }
                  if(typeof(mydata.activity5[0].abstraction[0].alternateSolution.length)!='undefined'){
                    len=len+mydata.activity5[0].abstraction[0].alternateSolution.length
                  }
                  if(text.algorithm.includes('nitesh')==true){
                    var newalgo=text.algorithm.split('nitesh')
                  }
                  var tim=''
                  var spc=''
                  if(text.analysis.includes(',')==true){
                    var arr = text.analysis.split(',')
                    var newarr1=arr[0].split('=')
                    var newarr2=arr[1].split('=')
                    tim = newarr1[1]
                    spc = newarr2[1]
                  }
                  return (
                  text.algoCompleted==true?
                  <GridItem xs={12} sm={6} md={6} key={index}>
                      {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','algorithm')}
                  </GridItem> 
                    :null
                  )}})}
                  <GridItem xs={12} sm={12} md={6}>
                    {totalSolutionComparison(mydata.activity5[0].decomposition[0].userText,mydata.activity5[0].pattern[0].userText,mydata.activity5[0].abstraction[0].userText,
                      mydata.activity5[0].algorithm[0].userText,mydata.activity5[0].analysis[0].timeText,mydata.activity5[0].analysis[0].spaceText,1,'correct')}
              </GridItem>
              
              <GridItem xs={12} sm={12} md={4}>
                                  {mydata.activity5[0].completed==true?
                                    <Card>
                                        <CardHeader color="success">
                                            <h5 style={classes.cardTitleWhite}> Overall Profile Score </h5>
                                        </CardHeader>
                                        <CardBody>
                                            <div style={{ width: "70%" }}>

                                                <CircularProgressbar
                                                        value={Number(mydata.activity5[0].profileScore).toFixed(2)}
                                                        text={`${Number(mydata.activity4[0].profileScore).toFixed(2)}%`}
                                                        background
                                                        backgroundPadding={6}
                                                        styles={buildStyles({
                                                        backgroundColor: "#3e98c7",
                                                        textColor: "#fff",
                                                        pathColor: "#fff",
                                                        trailColor: "transparent"
                                                        })}
                                                    />
                                            </div>                                             
                                        </CardBody>
                                    </Card>:null}
                                </GridItem>
      </GridContainer>
      {tableAnalytics(mydata.activity5,'activity5')}
      </>
        :activeStep==5?
        <>
          <GridItem xs={12} sm={12} md={12}>
            <h5 id="simple-modal-description" align="center"> {mydata.activity6[0].problemStatement} </h5>
          </GridItem>
        <GridContainer spacing={2}>
              {mydata.activity6[0].decomposition[0].alternateSolution.map((text, index)=>{
                if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                if(text.algorithm.includes('nitesh')==true){
                  var newalgo=text.algorithm.split('nitesh')
                }
                var tim=''
                var spc=''
                if(text.analysis.includes(',')==true){
                  var arr = text.analysis.split(',')
                  var newarr1=arr[0].split('=')
                  var newarr2=arr[1].split('=')
                  tim = newarr1[1]
                  spc = newarr2[1]
                }
                  return (
                    text.algoCompleted==true?
                    
                    <GridItem xs={12} sm={6} md={6} key={index}>
                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','decomposition')}
                    </GridItem> 
                    :null
                  )}})}
                {mydata.activity6[0].pattern[0].alternateSolution.map((text, index)=>{
                  if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                  var len=0;
                  if(typeof(mydata.activity6[0].decomposition[0].alternateSolution.length)!='undefined'){
                    len=mydata.activity6[0].decomposition[0].alternateSolution.length
                  }
                  if(text.algorithm.includes('nitesh')==true){
                    var newalgo=text.algorithm.split('nitesh')
                  }
                  var tim=''
                  var spc=''
                  if(text.analysis.includes(',')==true){
                    var arr = text.analysis.split(',')
                    var newarr1=arr[0].split('=')
                    var newarr2=arr[1].split('=')
                    tim = newarr1[1]
                    spc = newarr2[1]
                  }
                  return (
                  text.algoCompleted==true?
                  <GridItem xs={12} sm={6} md={6} key={index}>
                      {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','pattern')}
                  </GridItem> 
                  :null
                )}})}
                {mydata.activity6[0].abstraction[0].alternateSolution.map((text, index)=>{
                  if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                var len=0;
                if(typeof(mydata.activity6[0].decomposition[0].alternateSolution.length)!='undefined'){
                  len=mydata.activity6[0].decomposition[0].alternateSolution.length
                }
                if(typeof(mydata.activity6[0].pattern[0].alternateSolution.length)!='undefined'){
                  len=len+mydata.activity6[0].pattern[0].alternateSolution.length
                }
                if(text.algorithm.includes('nitesh')==true){
                  var newalgo=text.algorithm.split('nitesh')
                }
                var tim=''
                var spc=''
                if(text.analysis.includes(',')==true){
                  var arr = text.analysis.split(',')
                  var newarr1=arr[0].split('=')
                  var newarr2=arr[1].split('=')
                  tim = newarr1[1]
                  spc = newarr2[1]
                }
                return (
                text.algoCompleted==true?
                  <GridItem xs={12} sm={6} md={6} key={index}>
                    {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','abstraction')}
                  </GridItem>  
                :null
                )}})}
                {mydata.activity6[0].algorithm[0].alternateSolution.map((text, index)=>{
                  if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                  var len=0;
                  if(typeof(mydata.activity6[0].decomposition[0].alternateSolution.length)!='undefined'){
                    len=mydata.activity6[0].decomposition[0].alternateSolution.length
                  }
                  if(typeof(mydata.activity6[0].pattern[0].alternateSolution.length)!='undefined'){
                    len=len+mydata.activity6[0].pattern[0].alternateSolution.length
                  }
                  if(typeof(mydata.activity6[0].abstraction[0].alternateSolution.length)!='undefined'){
                    len=len+mydata.activity6[0].abstraction[0].alternateSolution.length
                  }
                  if(text.algorithm.includes('nitesh')==true){
                    var newalgo=text.algorithm.split('nitesh')
                  }
                  var tim=''
                  var spc=''
                  if(text.analysis.includes(',')==true){
                    var arr = text.analysis.split(',')
                    var newarr1=arr[0].split('=')
                    var newarr2=arr[1].split('=')
                    tim = newarr1[1]
                    spc = newarr2[1]
                  }
                  return (
                  text.algoCompleted==true?
                  <GridItem xs={12} sm={6} md={6} key={index}>
                      {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','algorithm')}
                  </GridItem> 
                    :null
                  )}})}
                  <GridItem xs={12} sm={12} md={6}>
                    {totalSolutionComparison(mydata.activity6[0].decomposition[0].userText,mydata.activity6[0].pattern[0].userText,mydata.activity6[0].abstraction[0].userText,
                      mydata.activity6[0].algorithm[0].userText,mydata.activity6[0].analysis[0].timeText,mydata.activity6[0].analysis[0].spaceText,1,'correct')}
              </GridItem>
              
              <GridItem xs={12} sm={12} md={4}>
                                  {mydata.activity6[0].completed==true?
                                    <Card>
                                        <CardHeader color="success">
                                            <h5 style={classes.cardTitleWhite}> Overall Profile Score </h5>
                                        </CardHeader>
                                        <CardBody>
                                            <div style={{ width: "70%" }}>
                                                <CircularProgressbar
                                                        value={Number(mydata.activity6[0].profileScore).toFixed(2)}
                                                        text={`${Number(mydata.activity6[0].profileScore).toFixed(2)}%`}
                                                        background
                                                        backgroundPadding={6}
                                                        styles={buildStyles({
                                                        backgroundColor: "#3e98c7",
                                                        textColor: "#fff",
                                                        pathColor: "#fff",
                                                        trailColor: "transparent"
                                                        })}
                                                    />
                                            </div>                                             
                                        </CardBody>
                                    </Card>:null}
                                </GridItem>
      </GridContainer>
      {tableAnalytics(mydata.activity6,'activity6')}
      </>
        :activeStep==6?
        <>
                    <GridItem xs={12} sm={12} md={12}>
                      <h5 id="simple-modal-description" align="center"> {mydata.activity7[0].problemStatement} </h5>
                    </GridItem>
        <GridContainer spacing={2}>
              {mydata.activity7[0].decomposition[0].alternateSolution.map((text, index)=>{
                if(text.algorithm.includes('nitesh')==true){
                  var newalgo=text.algorithm.split('nitesh')
                }
                var tim=''
                var spc=''
                if(text.analysis.includes(',')==true){
                  var arr = text.analysis.split(',')
                  var newarr1=arr[0].split('=')
                  var newarr2=arr[1].split('=')
                  tim = newarr1[1]
                  spc = newarr2[1]
                }
                  return (
                    text.algoCompleted==true?
                    
                    <GridItem xs={12} sm={6} md={6} key={index}>
                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','decomposition')}
                    </GridItem> 
                    :null
                  )})}
                {mydata.activity7[0].pattern[0].alternateSolution.map((text, index)=>{
                  var len=0;
                  if(typeof(mydata.activity7[0].decomposition[0].alternateSolution.length)!='undefined'){
                    len=mydata.activity7[0].decomposition[0].alternateSolution.length
                  }
                  if(text.algorithm.includes('nitesh')==true){
                    var newalgo=text.algorithm.split('nitesh')
                  }
                  var tim=''
                  var spc=''
                  if(text.analysis.includes(',')==true){
                    var arr = text.analysis.split(',')
                    var newarr1=arr[0].split('=')
                    var newarr2=arr[1].split('=')
                    tim = newarr1[1]
                    spc = newarr2[1]
                  }
                  return (
                  text.algoCompleted==true?
                  <GridItem xs={12} sm={6} md={6} key={index}>
                      {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','pattern')}
                  </GridItem> 
                  :null
                )})}
                {mydata.activity7[0].abstraction[0].alternateSolution.map((text, index)=>{
                var len=0;
                if(typeof(mydata.activity7[0].decomposition[0].alternateSolution.length)!='undefined'){
                  len=mydata.activity7[0].decomposition[0].alternateSolution.length
                }
                if(typeof(mydata.activity7[0].pattern[0].alternateSolution.length)!='undefined'){
                  len=len+mydata.activity7[0].pattern[0].alternateSolution.length
                }
                if(text.algorithm.includes('nitesh')==true){
                  var newalgo=text.algorithm.split('nitesh')
                }
                var tim=''
                var spc=''
                if(text.analysis.includes(',')==true){
                  var arr = text.analysis.split(',')
                  var newarr1=arr[0].split('=')
                  var newarr2=arr[1].split('=')
                  tim = newarr1[1]
                  spc = newarr2[1]
                }
                return (
                text.algoCompleted==true?
                  <GridItem xs={12} sm={6} md={6} key={index}>
                    {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','abstraction')}
                  </GridItem>  
                :null
                )})}
                {mydata.activity7[0].algorithm[0].alternateSolution.map((text, index)=>{
                  var len=0;
                  if(typeof(mydata.activity7[0].decomposition[0].alternateSolution.length)!='undefined'){
                    len=mydata.activity7[0].decomposition[0].alternateSolution.length
                  }
                  if(typeof(mydata.activity7[0].pattern[0].alternateSolution.length)!='undefined'){
                    len=len+mydata.activity7[0].pattern[0].alternateSolution.length
                  }
                  if(typeof(mydata.activity7[0].abstraction[0].alternateSolution.length)!='undefined'){
                    len=len+mydata.activity7[0].abstraction[0].alternateSolution.length
                  }
                  if(text.algorithm.includes('nitesh')==true){
                    var newalgo=text.algorithm.split('nitesh')
                  }
                  var tim=''
                  var spc=''
                  if(text.analysis.includes(',')==true){
                    var arr = text.analysis.split(',')
                    var newarr1=arr[0].split('=')
                    var newarr2=arr[1].split('=')
                    tim = newarr1[1]
                    spc = newarr2[1]
                  }
                  return (
                  text.algoCompleted==true?
                  <GridItem xs={12} sm={6} md={6} key={index}>
                      {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,'2','algorithm')}
                  </GridItem> 
                    :null
                  )})}
                  <GridItem xs={12} sm={12} md={6}>
                    {totalSolutionComparison(mydata.activity7[0].decomposition[0].userText,mydata.activity7[0].pattern[0].userText,mydata.activity7[0].abstraction[0].userText,
                      mydata.activity7[0].algorithm[0].userText,mydata.activity7[0].analysis[0].timeText,mydata.activity7[0].analysis[0].spaceText,1,'correct')}
              </GridItem>
              
              <GridItem xs={12} sm={12} md={4}>
                                  {mydata.activity7[0].completed==true?
                                    <Card>
                                        <CardHeader color="success">
                                            <h5 style={classes.cardTitleWhite}> Overall Profile Score </h5>
                                        </CardHeader>
                                        <CardBody>
                                            <div style={{ width: "70%" }}>
                                                <CircularProgressbar
                                                        value={Number(mydata.activity7[0].profileScore).toFixed(2)}
                                                        text={`${Number(mydata.activity7[0].profileScore).toFixed(2)}%`}
                                                        background
                                                        backgroundPadding={6}
                                                        styles={buildStyles({
                                                        backgroundColor: "#3e98c7",
                                                        textColor: "#fff",
                                                        pathColor: "#fff",
                                                        trailColor: "transparent"
                                                        })}
                                                    /> 
                                            </div>                                            
                                        </CardBody>
                                    </Card>:null}
                                </GridItem>
      </GridContainer>
      {tableAnalytics(mydata.activity7,'activity7')}
      </>
        :null}
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={8}>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
                <Button disabled={activeStep === 0} onClick={handleBack} sx={classes.button}>
                  Back
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  disabled ={done==true?false:true}
                  onClick={handleNext}
                  sx={classes.button}
                >
                  Next
                </Button>
        </GridItem>
      </GridContainer>
      </div>
    </div>
    </GridContainer>:null
  );
}